module.exports = __webpack_public_path__ + "img/num3.016ec905.png";